import { initTranslation, i18n } from "../modules/i18n";
import initPage from "../modules/page";
import "../../scss/sitemap.scss";

/**
 *
 * @param link
 */
const updateLinkVisual = (link) => {
  if (link.classList.contains("more")) {
    link.classList.remove("more");
    link.classList.add("less");
    link.setAttribute("aria-expanded", true);
    link.setAttribute("aria-label", `${i18n("sitemap.accordion.close")}`);
  } else {
    link.classList.add("more");
    link.classList.remove("less");
    link.setAttribute("aria-expanded", false);
    link.setAttribute("aria-label", `${i18n("sitemap.accordion.expand")}`);
  }
};

/**
 *
 * @param target
 * @param link
 * @param duration
 */
const slideUp = (target, link, duration = 300) => {
  updateLinkVisual(link);
  // Give the targetent a height to change from
  target.style.maxHeight = target.scrollHeight + "px";

  //Set max-height to zero, trigger css animation.
  target.style.maxHeight = "0";

  // Set a temporary collapsing state to set opacity and to hook into in future.
  target.classList.add("is-collapsing");

  // When the transition is complete, hide it
  window.setTimeout(function () {
    target.classList.remove("is-visible");
    target.classList.remove("is-collapsing");
  }, duration);
};

/**
 *
 * @param target
 * @param link
 * @param duration
 */
const slideDown = (target, link, duration = 300) => {
  // Play the plus/minus transition.
  updateLinkVisual(link);

  // Get parent list and remove the max height if there is one as we no longer need it.
  const listParent = link.closest(".site-map-sub-list");

  if (listParent !== null && listParent !== undefined) {
    listParent.style.removeProperty("max-height");
  }

  // Set a temporary expanding state to set opacity and to hook into in future.
  target.classList.add("is-expanding");

  // Reveal, get height, hide again.
  var getHeight = function () {
    target.style.display = "block";
    var height = target.scrollHeight + "px";
    target.style.display = "";
    return height;
  };

  //Get Height.
  var height = getHeight();
  //Set visibility class.
  target.classList.add("is-visible");
  // Update the max-height.
  target.style.maxHeight = height;

  window.setTimeout(function () {
    target.classList.remove("is-expanding");
  }, duration);
};

/**
 *
 * @param target
 * @param link
 * @param duration
 */
const slideToggle = (target, link, duration = 300) => {
  if (!target.classList.contains("is-visible")) {
    return slideDown(target, link, duration);
  } else {
    return slideUp(target, link, duration);
  }
};

/**
 *
 * @param event
 * @returns {boolean}
 */
const setUpClickDelegator = (event) => {
  if (event.target.classList.contains("js-site-map-children")) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const smLink = event.target;
    const smList = smLink.parentNode.querySelector(".site-map-sub-list");
    slideToggle(smList, smLink);
  }
  return false;
};

async function initSiteMap() {
  await initTranslation();
  initPage();

  const siteMapPage = document.querySelector(".site-map");
  siteMapPage.addEventListener("click", (e) => {
    setUpClickDelegator(e);
  });
}

initSiteMap();
